import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-hidden"]
const _hoisted_2 = { class: "modal-header-corner" }
const _hoisted_3 = ["title"]
const _hoisted_4 = {
  key: 0,
  class: "account-settings-logout-link"
}
const _hoisted_5 = { class: "modal-body no-padding" }
const _hoisted_6 = { class: "settings-list" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "settings-list-item-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-language" })
], -1)
const _hoisted_8 = { class: "settings-list-item-caption" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "settings-list-item-arrow" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-right" })
], -1)
const _hoisted_10 = { class: "settings-list-item-icon" }
const _hoisted_11 = {
  key: 0,
  class: "fas fa-sun"
}
const _hoisted_12 = {
  key: 1,
  class: "fas fa-moon"
}
const _hoisted_13 = { class: "settings-list-item-caption" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "settings-list-item-arrow" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-right" })
], -1)
const _hoisted_15 = {
  key: 0,
  class: "modal-body no-padding border-top"
}
const _hoisted_16 = { class: "settings-list" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "settings-list-item-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-wallet" })
], -1)
const _hoisted_18 = { class: "settings-list-item-caption" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "settings-list-item-arrow" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-right" })
], -1)
const _hoisted_20 = { class: "modal-body no-padding border-top" }
const _hoisted_21 = { class: "settings-list" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "settings-list-item-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user" })
], -1)
const _hoisted_23 = { class: "settings-list-item-caption" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "settings-list-item-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-tag" })
], -1)
const _hoisted_25 = { class: "settings-list-item-caption" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "settings-list-item-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope" })
], -1)
const _hoisted_27 = { class: "settings-list-item-caption" }
const _hoisted_28 = { class: "modal-body no-padding border-top" }
const _hoisted_29 = { class: "settings-list" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "settings-list-item-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-key" })
], -1)
const _hoisted_31 = { class: "settings-list-item-caption" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "settings-list-item-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock" })
], -1)
const _hoisted_33 = { class: "settings-list-item-caption" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "settings-list-item-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock-open" })
], -1)
const _hoisted_35 = { class: "settings-list-item-caption" }
const _hoisted_36 = { class: "modal-body no-padding border-top" }
const _hoisted_37 = { class: "settings-list" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "settings-list-item-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-mobile" })
], -1)
const _hoisted_39 = { class: "settings-list-item-caption" }
const _hoisted_40 = { class: "modal-body no-padding border-top" }
const _hoisted_41 = { class: "settings-list" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "settings-list-item-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question" })
], -1)
const _hoisted_43 = { class: "settings-list-item-caption" }
const _hoisted_44 = { class: "modal-body no-padding border-top" }
const _hoisted_45 = { class: "settings-list" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "settings-list-item-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" })
], -1)
const _hoisted_47 = { class: "settings-list-item-caption" }
const _hoisted_48 = { class: "settings-list" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "settings-list-item-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sign-out-alt" })
], -1)
const _hoisted_50 = { class: "settings-list-item-caption" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal-container modal-container-corner no-transition", { hidden: !_ctx.display }]),
    tabindex: "-1",
    role: "dialog",
    "aria-hidden": !_ctx.display,
    onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
    onKeydown: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.escapeToClose && _ctx.escapeToClose(...args)))
  }, [
    _createElementVNode("div", {
      class: "modal-dialog modal-md",
      role: "document",
      onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.stopPropagationEvent && _ctx.stopPropagationEvent(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "account-settings-username",
          title: _ctx.username
        }, "@" + _toDisplayString(_ctx.username), 9, _hoisted_3),
        (_ctx.admin)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t("Site administrator")), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "settings-list-item",
            tabindex: "0",
            onKeydown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickOnEnter && _ctx.clickOnEnter(...args))),
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openSelectLanguage && _ctx.openSelectLanguage(...args)))
          }, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("Language")) + ": " + _toDisplayString(_ctx.renderLanguage(_ctx.lang, _ctx.languages)), 1),
            _hoisted_9
          ], 32),
          _createElementVNode("div", {
            class: "settings-list-item",
            tabindex: "0",
            onKeydown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickOnEnter && _ctx.clickOnEnter(...args))),
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openSelectTheme && _ctx.openSelectTheme(...args)))
          }, [
            _createElementVNode("div", _hoisted_10, [
              (!_ctx.isDarkTheme)
                ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                : _createCommentVNode("", true),
              (_ctx.isDarkTheme)
                ? (_openBlock(), _createElementBlock("i", _hoisted_12))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("Theme")) + ": " + _toDisplayString(_ctx.renderTheme(_ctx.isDarkTheme)), 1),
            _hoisted_14
          ], 32)
        ])
      ]),
      (_ctx.verified)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", {
                class: "settings-list-item",
                tabindex: "0",
                onKeydown: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickOnEnter && _ctx.clickOnEnter(...args))),
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openWalletSettings && _ctx.openWalletSettings(...args)))
              }, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("Wallet")) + ": " + _toDisplayString(_ctx.renderWallet(_ctx.walletAddress)), 1),
                _hoisted_19
              ], 32)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          (_ctx.verified)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "settings-list-item",
                tabindex: "0",
                onKeydown: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clickOnEnter && _ctx.clickOnEnter(...args))),
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openProfile && _ctx.openProfile(...args)))
              }, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("Profile")), 1)
              ], 32))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "settings-list-item",
            tabindex: "0",
            onKeydown: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.clickOnEnter && _ctx.clickOnEnter(...args))),
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.openChangeUsername && _ctx.openChangeUsername(...args)))
          }, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("Change username")), 1)
          ], 32),
          _createElementVNode("div", {
            class: "settings-list-item",
            tabindex: "0",
            onKeydown: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.clickOnEnter && _ctx.clickOnEnter(...args))),
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.openChangeEmail && _ctx.openChangeEmail(...args)))
          }, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("Change email")), 1)
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", {
            class: "settings-list-item",
            tabindex: "0",
            onKeydown: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.clickOnEnter && _ctx.clickOnEnter(...args))),
            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.openChangePassword && _ctx.openChangePassword(...args)))
          }, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("Change password")), 1)
          ], 32),
          (!_ctx.tfa)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "settings-list-item",
                tabindex: "0",
                onKeydown: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.clickOnEnter && _ctx.clickOnEnter(...args))),
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.enableTFAOpen && _ctx.enableTFAOpen(...args)))
              }, [
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t("Enable two factor authentication")), 1)
              ], 32))
            : _createCommentVNode("", true),
          (_ctx.tfa)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "settings-list-item",
                tabindex: "0",
                onKeydown: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.clickOnEnter && _ctx.clickOnEnter(...args))),
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.disableTFAOpen && _ctx.disableTFAOpen(...args)))
              }, [
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t("Disable two factor authentication")), 1)
              ], 32))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", {
            class: "settings-list-item",
            tabindex: "0",
            onKeydown: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.clickOnEnter && _ctx.clickOnEnter(...args))),
            onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.openDevicesList && _ctx.openDevicesList(...args)))
          }, [
            _hoisted_38,
            _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t("Devices")), 1)
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", {
            class: "settings-list-item",
            tabindex: "0",
            onKeydown: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.clickOnEnter && _ctx.clickOnEnter(...args))),
            onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.openAdviceConfig && _ctx.openAdviceConfig(...args)))
          }, [
            _hoisted_42,
            _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t("Advices")), 1)
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", {
            class: "settings-list-item",
            tabindex: "0",
            onKeydown: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.clickOnEnter && _ctx.clickOnEnter(...args))),
            onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.openAccountDelete && _ctx.openAccountDelete(...args)))
          }, [
            _hoisted_46,
            _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t("Delete account")), 1)
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", {
            class: "settings-list-item",
            tabindex: "0",
            onKeydown: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.clickOnEnter && _ctx.clickOnEnter(...args))),
            onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
          }, [
            _hoisted_49,
            _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$t("Log out")), 1)
          ], 32)
        ])
      ])
    ])
  ], 42, _hoisted_1))
}